import { render, staticRenderFns } from "./Undefeated.vue?vue&type=template&id=d274755c&scoped=true&"
import script from "./Undefeated.vue?vue&type=script&lang=js&"
export * from "./Undefeated.vue?vue&type=script&lang=js&"
import style0 from "./Undefeated.vue?vue&type=style&index=0&id=d274755c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d274755c",
  null
  
)

export default component.exports